import { useState, } from 'react';

/**
 * A checkmark toggle component.
 *
 * The toggle is off by default and displays a customizable label.
 *
 * @param {Object} props
 * @param {string} props.label
 * Text displayed next to the checkbox.
 *
 * @param {(checked: boolean) => void} [props.onChange]
 * Callback invoked when the toggle changes.
 *
 * @returns {JSX.Element}
 */
export default function CheckmarkToggle({ label, onChange, initiallyChecked = false, }) {
  const [checked, setChecked] = useState(initiallyChecked);

  const handleChange = () => {
    const nextValue = !checked;

    setChecked(nextValue);
    onChange?.(nextValue);
  };

  return (
    <label className="inline-flex cursor-pointer select-none items-center gap-3">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className="peer sr-only"
      />

      <span
        className="
          flex h-5 w-5 items-center justify-center
          rounded border-2 border-gray-500
          bg-[#333] text-transparent
          transition-colors
          peer-checked:border-neutral-600
          peer-checked:bg-[#f9a928]
        "
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          className="h-3.5 w-3.5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5 12l4 4L19 7"
          />
        </svg>
      </span>

      <span className="text-sm text-gray-200">
        {label}
      </span>
    </label>
  );
}
